module.exports = __webpack_public_path__ + "img/desaparecidos6.e75a3a0c.jpg";